import {
  login
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import Cookies from 'js-cookie'
const user = {
  state: {
    token: getToken(),
    currentTab: 0,
    // tel: getTokenByKey('tel'),
    baseInfo: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_CURRENT_TAB: (state, currentTab) => {
      state.currentTab = currentTab
    },
    SET_BASEINFO: (state, data) => {
      state.baseInfo = data
    }
  },
  actions: {
    GetUserInfo({
      commit,
      state
    }, data = {}) {
      return new Promise((resolve, reject) => {
        let userId = data.id || JSON.parse(getTokenByKey('userId') || null)
        console.log(userId)
        if (userId) {
          if (data.id != undefined && data.id == state.baseInfo.id && !data.refresh) {
            resolve(state.baseInfo)
            return
          }
          getInfo(userId).then(res => {
            if (res.data) {
              setTokenByKey('userId', res.data.id)
              commit('SET_BASEINFO', res.data)
              res.data.tel && setTokenByKey('tel', res.data.tel.trim())
            }
            resolve()
          }).catch(err => {
            console.log(err)
            resolve({
              noLogin: true
            })
          })
        } else {
          resolve({
            noLogin: true
          })
        }
      })
    },
    // user login
    Login({
      commit
    }, userInfo) {
      const {
        username,
        password
      } = userInfo
      return new Promise((resolve, reject) => {
        login({
          account: username.trim(),
          password: password
        }).then(response => {
          const {
            data
          } = response
          commit('SET_TOKEN', data)
          Cookies.set('userName', username.trim())
          setToken(data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // user logout
    Logout({
      commit
    }) {
      return new Promise((resolve) => {
        removeToken() 
        Cookies.remove('userName')
        commit('SET_TOKEN', '')
        resolve()
      })
    },
    // user logout
    ClickTab({
      commit
    }, currentTab) {
      return new Promise((resolve) => {
        commit('SET_CURRENT_TAB', currentTab)
        resolve()
      })
    }
  }
}

export default user